module.exports = __webpack_public_path__ + "fefe449b0cc9e66206ce0ea623d4e5f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/lawbreakers/grandview.png
// module id = 1070
// module chunks = 0